(function ($) {
	"use strict";
	
	class wpCalorieCalculator extends elementorModules.frontend.handlers.Base {
		getDefaultSettings() {
			return {
				selectors: {
					widget: ".wpcc-elementor-block",
				},
			};
		}

		getDefaultElements() {
			const selectors = this.getSettings("selectors");

			return {
				$widgets: this.findElement(selectors.widget),
			};
		}

		bindEvents() {}

		onInit(...args) {
			window.wpcc.init();
			super.onInit(...args);
		}
	}

	$(window).on("elementor/frontend/init", () => {
		elementorFrontend.elementsHandler.attachHandler('wp-calorie-calculator-widget', wpCalorieCalculator);
	});
})(jQuery);
